
var Model = require("../types/Model.js");
// eslint-disable-next-line node/no-missing-require
var Platform = require("react-native").Platform;
var BackgroundCheckModule = require("react-native-background-check");

var RECENT_INTERVAL = 2 * 1000;

module.exports = Model({
	name: "callfocuser",
	init: init,
	listeners: listeners,
	triggers: triggers,

	_focus: true,
	_previousFocues: true,

	recentlyFocused: recentlyFocused,
	focus: focus,
	unfocus: unfocus
});

function init() {
	if(Platform.OS === "web")
		this._focus = false;
	this.push(false);
}

function listeners() {
	return {
		"calling:statechange": checkIfShouldFocus,
		"screenfocus:updated": saveFocus,
	};
}

function triggers() {
	return {
		"set": setFocused,
		"focus": focus,
		"unfocus": unfocus
	};
}

function checkIfShouldFocus(state) {
	if(!BackgroundCheckModule) return;
	if (state === "receiving" && (!this._focus || this.recentlyFocused()) && (!this.data)) {
		this.focus();
	}
	if(state === "idle") {
		BackgroundCheckModule.clearWindow();
	}
	if (state === "idle" && this.data) {
		this.unfocus();
	}
}

function focus() {
	if(!BackgroundCheckModule) return;
	BackgroundCheckModule.bringApptoForeground();
	this.push(true);
}

function unfocus() {
	if(!BackgroundCheckModule) return;
	BackgroundCheckModule.bringApptoBackground();
	this.push(false);
}

function setFocused(data) {
	var focused = data.focused;
	this.push(focused);
}

function recentlyFocused() {
	var currentTime = Date.now();
	var delta = currentTime - (this._focus || 0);
	return delta < RECENT_INTERVAL;
}

function saveFocus(newFocus) {
	if (newFocus && Platform.OS !== "web")
		this._focus = Date.now();
	else this._focus = false;
}
